(function(){
  var embeds = document.querySelectorAll('[data-youtube-video]');
  window.youtubePlayers = []
  if (embeds.length > 0) {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    
    setInterval(function() {
      window.youtubePlayers.forEach(function(elem, it) {
        if (elem.fullDuration > 0) {
          if(elem.alreadyWatched) {
        	elem.subscribeButton.innerText = "Get your discount";
            elem.subscribeButton.onclick = function() {
              showVideoSubscriptionForm();
            };
          } else {
            elem.subscribeButton.innerText = "watch video, subscribe and get a discount (" + Math.round(elem.fullDuration - elem.getCurrentTime()).toString() + "s)";
            elem.subscribeButton.onclick = function() {
              elem.playVideo();
            };
          }
        }
      });
    },500);
  }
    
  function onYouTubeIframeAPIReady() {
    var embeds = document.querySelectorAll('[data-youtube-video]');
    var player = null;
    embeds.forEach(function(elem, it) {
      var playerElem = document.createElement('div');
      var button = document.createElement('button');
      button.className = "bttn";
      elem.insertBefore(playerElem, null);
      elem.insertBefore(button, null);

      player = new YT.Player(playerElem, {
        height: '390',
        width: '640',
//         playerVars: { 'autoplay': 1, 'controls': 0 },
        playerVars: { 'controls': 0 },
        videoId: elem.dataset.youtubeVideo,
        events: {
//           'onReady': function(event) {event.target.playVideo(); event.target.fullDuration = event.target.getDuration();},
          'onReady': function(event) {event.target.fullDuration = event.target.getDuration();},
          'onStateChange': function(event) {
            if (event.data == YT.PlayerState.ENDED) {
              event.target.alreadyWatched = true;
            }
          }
        }
      });
      player.subscribeButton = button;
      player.fullDuration = 0;
      window.youtubePlayers.push(player);
    });
  }
  
  function showVideoSubscriptionForm() {
    document.getElementById('video-subscription-form').style.display = "block";
  }

  window.showVideoSubscriptionForm = showVideoSubscriptionForm;
  window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
})();